import "./TimerIcon.css";

// Assuming your CSS is in this file
const TimerComponent = () => {
  return (
    <>
      <svg
        width="17"
        height="17"
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="50"
          cy="50"
          r="45"
          stroke="black"
          stroke-width="8"
          fill="none"
        />

        <rect
          x="45"
          y="5"
          width="5"
          height="5"
          stroke="black"
        />

        <g className="animate-inner">
          <line
            x1="50"
            y1="50"
            x2="50"
            y2="25"
            stroke="black"
            stroke-width="5"
            stroke-linecap="round"
          />
        </g>
      </svg>
    </>
  );
};

export default TimerComponent;
